module.exports = __webpack_public_path__ + "static/media/X_TIBET.9a12efd2.svg";